import Vue from 'vue'
import Router from 'vue-router'
import login from '@/page/login'
import adminLogin from '@/page/admin/login'
//import videoPlayer from '@/page/videoPlayer'
import videoAppointmentList from '@/page/videoAppointmentList'
import wechatResponse from "@/page/wechatResponse"

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [{
      //path: '/login',
      path: '/',
      name: 'login',
      meta: {
        requireAuth: false,
      },
      component: login
    },
    // {
    //   path: '/',
    //   name: 'adminLogin',
    //   component: adminLogin,
    //   meta: {
    //     requireAuth: false,
    //   },
    //   children: []
    // },
    // {
    //   path: '/player/:id',
    //   name: 'videoPlayer',
    //   component: videoPlayer,
    //   meta: {
    //     requireAuth: false,
    //   },
    //   children: []
    // },
    {
      path: '/appointmentList',
      name: 'videoAppointmentList',
      component: videoAppointmentList,
      meta: {
        requireAuth: false,
      },
      children: []
    },
    {
      path:'/wechatResponse',   
      meta:{
        requireAuth:true,
      }, 
      component: wechatResponse
    },
    {
      path: '/pendingContracts',
      name: 'pendingContracts',
      meta: {
        requireAuth: true,
      },
      component: () => import('@/page/pendingContracts')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js